<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">

        <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="freezerRequestForm"
          :redirect-detail="true"
          :show-add-button="accessLevel"
          caption="<i class='fa fa-align-justify'></i> Request Freezer Listing"
          addButton="Tambah Request Freezer"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Form Permintaan Freezer</h3>
        </div>

        <div v-if="!loadingSubmit">
          <b-form id="req" validated novalidate @submit="submitAdd">
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="product_group" label="Konsumen">
                    <vue-autosuggest
                        v-model="customers.text"
                        @inputout="focusMe"
                        :suggestions="filteredOptions"
                        @input="onInputChange"
                        @selected="onSelected"
                        :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control'}"
                        :limit="20"
                    >
                        <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item"> 
                            {{ suggestion.item.text }}
                        </span>
                        </template>
                    </vue-autosuggest>
                    <div
                    v-if="freezerRequestForm.customer_id === null"
                    class="invalid-feedback-custom"
                  >Konsumen harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="request_type" label="Tipe Permintaan">
                  <model-select
                    id="request_type"
                    :options="listRequestType"
                    v-model="$v.freezerRequestForm.request_type.$model"
                    :isError="$v.freezerRequestForm.request_type.$invalid"
                    :disabled="true"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="freezerRequestForm.request_type === null"
                    class="invalid-feedback-custom"
                  >Tipe permintaan harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row>
                <b-col sm="6">
                  <b-form-group label-for="notes" label="Notes">
                    <b-form-textarea
                      id="notes"
                      :rows="3"
                      :max-rows="6"
                      v-model="freezerRequestForm.notes"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Notes harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.freezerRequestForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import { VueAutosuggest } from 'vue-autosuggest';
import loading from "@/templates/Loading.vue";

export default {
  name: "request-freezer",
  components: { globalTable, ModelSelect, loading, VueAutosuggest },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listRequestType: [],
      listStatus: [],
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      filteredOptions: [],
      customers: {
        text: null,
        value: null
      },
      suggestions: [
        {
          data: [],
        },
      ],
      fields: [
        { key: "request_code", label: "Kode Request", sortable: false, filterByFormatted: true },
        { key: "customer_name", label: "Nama Konsumen", sortable: true, filterByFormatted: true },
        { key: "request_type_name", label: "Jenis Request", sortable: true, filterByFormatted: true },
        { key: "date_inserted", label: "Tanggal Insert", sortable: false, filterByFormatted: true },
        { key: "process_time", label: "Tanggal Process", sortable: false, filterByFormatted: true },
        { key: "status_name", label: "Status", sortable: false, filterByFormatted: true },
        { key: "action", class: "text-center width-80" }
      ],
      freezerRequestForm: interfaces.freezer_request
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },  
  validations: {
    freezerRequestForm: {
      customer_id: { required },
      request_type: { required }
    }
  },
  computed: {
    accessLevel() {
      let employee_id = localStorage.getItem("nik");
      return (localStorage.getItem("level") === "1" || ['MBS22090004'].includes(employee_id)) ? true : false;
    }
  },
  methods: {
     focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.freezerRequestForm.customer_id = null;
        this.customers.value = null;
        this.customers.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.freezerRequestForm.customer_id = null;
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/assets/freezer-request/all', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    init: function() {
      this.getDropdown();
      this.resetForm();
    },

    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-request-freezer")
        .then(response => {
          this.listRequestType = response.data.request_type;
          this.listStatus = response.data.freezer_request_status;
        })
        .catch(error => {})
        .finally(() => {});
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.freezerRequestForm.customer_id = null;
        return;
      } else {
        this.freezerRequestForm.customer_id = item.item.value;
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
     }
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.freezer_request) {
        interfaces.freezer_request[a] = null;
      }
      this.freezerRequestForm = interfaces.freezer_request;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan request baru ?")) {
        this.loadingSubmit = true;
        let customer = this.freezerRequestForm;
        this.axios
          .post("web/assets/freezer-request/add/", customer)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Request Freezer",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Request Freezer",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>


<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>
